import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNServiceCode, CNServiceCodeExtra } from 'src/app/models/cnservicecode';

@Component({
  selector: 'app-service-code',
  templateUrl: './service-code.component.html',
  styleUrls: ['./service-code.component.scss']
})
export class ServiceCodeComponent implements OnInit {

  @Input() mode = 'none';
  @Output() action: EventEmitter<[action: string, code: CNServiceCode]> = new EventEmitter();

  public hasExtras = false;
  public extras: CNServiceCodeExtra[] = [];

  private theCode: CNServiceCode;

  constructor() { }

  ngOnInit(): void {
  }

  @Input() set code(theCode: CNServiceCode) {
    this.theCode = theCode;
    this.hasExtras = this.code.extras.length !== 0;
    this.extras = this.theCode.extras;
  }

  get code(): CNServiceCode {
    return this.theCode;
  }

  callAction(): void {
    this.action.emit([this.mode, this.code]);
  }

  getField(extra: string): string {
    return this.code.extraValue(extra);
  }

  setField(extra: string, value: string): void {
    this.code.setExtraValue(extra, value);
  }
}
